export default "__VITE_ASSET__CeoUh16t__"